/* Copyright (c) 2024-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { SpatialNavigation } from '../services/spatial-navigation/spatial-navigation-polyfill';

declare global {
    interface Element {
        getScrollSnapTarget?: () => HTMLElement;
    }
}

export function isScrollContainer(node: Node): boolean {
    const spatialNavigation: SpatialNavigation = window.__spatialNavigation__;
    return spatialNavigation?.isScrollContainer(node) ?? false;
}

export function getScrollContainer(element: HTMLElement): HTMLElement | null {
    if (!element?.isConnected) {
        return null;
    }

    let current = element;
    while (current && !isScrollContainer(current)) {
        current = current.parentElement;
    }
    return current;
}

export function getScrollSnapTarget(element: Element): Element {
    return element?.getScrollSnapTarget?.() ?? element;
}

export function getScrollSnapBoundingRect(element: Element): DOMRect {
    return getScrollSnapTarget(element).getBoundingClientRect();
}
